import clsx from 'clsx'

import { colors } from '~/@common/styles'
import type { StyleProps } from '~/@common/types'
import FireCrackerIcon from '/__external__/icons/icon_firecracker.svg'

import type { LearningContentStatus } from '@mathflat/domain/@entities/StudentWorksheet/api2'
import { S } from '.'

export type Props = {
  status: LearningContentStatus
  eduMaterialType: 'WORKSHEET' | 'WORKBOOK' | 'CONCEPTUAL' | 'EXAM'
  score?: number | null
  showScore?: boolean
  scoring: {
    total: number
    correct: number
    incorrect: number
    unknown: number
    none: number
  }
} & StyleProps

// TODO: 혜은) ProblemScoring 받게 해서 구현. 위치도 그 디렉토리 안으로
export const StudentEduMaterialScoringDashboard = ({
  status = 'INCOMPLETE',
  eduMaterialType,
  score = 0,
  showScore = true,
  scoring,

  ...props
}: Props) => {
  const isConceptualLearning = eduMaterialType === 'CONCEPTUAL'
  const sheetKR = (() => {
    if (eduMaterialType === 'WORKSHEET') return '학습지'
    if (eduMaterialType === 'EXAM') return '시험'
    return '교재'
  })()

  return (
    <S.Card {...props} className={clsx(isConceptualLearning && 'card-conceptual-learning')}>
      <div className="card__top">
        {!isConceptualLearning && (
          <p>
            {status === 'COMPLETE' || status === 'EXPIRED'
              ? `${sheetKR} 풀이결과`
              : '나머지 문제도 풀어보세요!'}
          </p>
        )}
        {status === 'COMPLETE' ? (
          <h2
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div>
              총 {scoring.total}문제 중<span className="top__font-blue">{scoring.correct}문제</span>
              맞혔어요!
            </div>
            <img src={FireCrackerIcon} width={28} height={28} />
          </h2>
        ) : (
          <h2>
            지금까지 <span className="top__font-blue">{scoring.correct}문제</span> 맞혔어요
          </h2>
        )}
      </div>
      {showScore && (
        <div className={clsx('card__middle', status === 'COMPLETE' && 'active-blue')}>
          <p className="middle__title">총점</p>
          <strong className="middle__totalScore">{score}점</strong>
        </div>
      )}
      <div className="card__bottom">
        <S.Brick>
          <p className="title">틀린 문제</p>
          <strong
            className="value"
            style={{
              color: colors.red.$300,
            }}
          >
            {scoring.incorrect + scoring.unknown}
          </strong>
        </S.Brick>
        <S.Brick>
          <p className="title">맞은 문제</p>
          <strong className="value">{scoring.correct}</strong>
        </S.Brick>
        {status !== 'COMPLETE' && (
          <S.Brick>
            <p className="title">안 푼 문제</p>
            <strong className="value">{scoring.none}</strong>
          </S.Brick>
        )}
      </div>
    </S.Card>
  )
}
